export default __webpack_public_path__ + "static/generative_ai_choose-f38ca9c15167d7f4ef83b34b176ca597.webp";